import React from 'react'
import { user } from 'ampersand-app'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import Loader from '@/modules/base/components/loader/loader'
import DocumentDetailPreview from '@/modules/document/components/edit/document-detail-preview'
import FixErrorsErrorPanel from './fix-errors-error-panel'
import { FailedDocument, FileInfoEntry } from './types'

const fixErrorsLang = lang.documentExport.fixErrors

interface FixErrorsDocumentStepProps {
  item: FailedDocument
  fileInfo?: FileInfoEntry
  onFileChange: (update: FileInfoEntry) => void
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  container: {
    display: 'flex',
    gap: 30,
    height: '100%',
  },
  previewContainer: {
    height: '100%',
  },
  preview: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  panel: {
    width: 400,
    flexShrink: 0,
  },
  infoBox: {
    padding: 20,
    border: theme.border,
    borderRadius: 4,
    backgroundColor: theme.backgroundColor,
  },
}))

const FixErrorsDocumentStep: React.FC<FixErrorsDocumentStepProps> = ({ item, fileInfo = {}, onFileChange }) => {
  const classes = useStyles()

  const { status, file, resolution } = fileInfo

  let preview
  if (resolution === 'deleted') {
    preview = <div className={classes.infoBox}>{fixErrorsLang.fileDeleted}</div>
  } else if (status === 'loading' || !status) {
    preview = <Loader visible={true} />
  } else if (status === 'loaded') {
    preview = (
      <DocumentDetailPreview
        file={file}
        hideControls
        disableOcr
        disableActions
        classNames={classes.previewContainer}
        downloadLabel={lang.generics.download}
        downloadUrl={`${file.url}?download=true&token=${user.token}`}
      />
    )
  } else {
    preview = (
      <div className={classes.infoBox}>
        {status === 'notFound' ? fixErrorsLang.fileNotFound : lang.defaultErrorMessage}
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <div className={classes.preview}>
        {preview}
      </div>
      <div className={classes.panel}>
        <FixErrorsErrorPanel item={item} fileInfo={fileInfo} onFileChange={onFileChange} />
      </div>
    </div>
  )
}

export default FixErrorsDocumentStep
